import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

export default class extends Controller {
  static values = {
    variant: String
  }

  connect() {
    if (AutoNumeric.isManagedByAutoNumeric(this.element)) return

    this.autoNumeric = new AutoNumeric(this.element, {
      ...this.baseOptions,
      ...this.variantOptions
    })
  }

  disconnect() {
    if (!this.autoNumeric) return

    this.autoNumeric.remove()
    this.autoNumeric = null
  }

  get baseOptions() {
    return {
      decimalCharacter: ".",
      decimalPlaces: 2,
      digitGroupSeparator: ",",
      emptyInputBehavior: "null",
      minimumValue: "0",
      modifyValueOnWheel: false,
      unformatOnSubmit: true,
      watchExternalChanges: true
    }
  }

  get variantOptions() {
    switch (this.variantValue) {
      case "currency":
        return { currencySymbol: "$" }
      case "percentage":
        return { suffixText: "%" }
      default:
        return {}
    }
  }
}
